import axios from "axios";
import {ActionTree} from "vuex";
import { EventAttributesState, EventAttributesItem, EventAttributesFilter } from "@/store/cdp/event_attributes/types";
import {RootState} from "@/store/types";

export const actions: ActionTree<EventAttributesState, RootState> = {
    getEventAttributes: ({commit}, data: EventAttributesFilter) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: '/cdp/v1/event/attributes', params: data})
                .then(resp => {
                    commit('setEventAttributes', resp.data);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    saveEventAttributes: ({commit, dispatch}, data: EventAttributesItem) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url: '/cdp/v1/event/attributes/',
                data: data
            })
                .then((resp: any) => {
                    dispatch('getEventAttributes');
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    getEventAttributesItem: ({commit}, key: string) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: `/cdp/v1/event/attributes/${key}`})
                .then((resp: any) => {
                    const eventAttributeItem = <EventAttributesItem>resp.data;
                    commit('setEventAttributeItem', eventAttributeItem);
                    resolve(eventAttributeItem);
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => commit('setLoading', false))
        })
    }
}

